import { render } from "./print-competitors.vue?vue&type=template&id=1cc53dea&scoped=true&lang=pug"
import script from "./print-competitors.vue?vue&type=script&lang=js"
export * from "./print-competitors.vue?vue&type=script&lang=js"

import "./print-competitors.vue?vue&type=style&index=0&id=1cc53dea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc53dea"]])

export default __exports__